/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Navigate, Outlet } from 'react-router-dom';

import { userStoreService } from '@adp-studio/user-store';

/**
 * User type based redirect component
 * - end_user: redirects to /explore (Agent Store)
 * - developer: redirects to /space
 */
export const UserTypeRedirect = () => {
    const userInfo = userStoreService.useUserInfo();
    const isEndUser = userInfo?.user_type === 'end_user';
    const defaultPath = isEndUser ? '/explore' : '/space';
    return <Navigate to={defaultPath} replace />;
};

/**
 * Guard component for space routes
 * Redirects end_user to /explore, allows developers to access /space
 */
export const EndUserGuard = () => {
    const userInfo = userStoreService.useUserInfo();
    const isEndUser = userInfo?.user_type === 'end_user';

    if (isEndUser) {
        return <Navigate to="/explore" replace />;
    }

    return <Outlet />;
};
